import * as Sentry from '@sentry/react';

Sentry.init({
  release: 'payblox-web-app@2025.13.0',
  dsn: import.meta.env.VITE_APP_SENTRY_DSN as string,
  enabled: import.meta.env.MODE !== 'development',
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
    Sentry.replayIntegration(),
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
});
